<template>
  <div>
    <st_header_cop
      :default_index11="'2'">
    </st_header_cop>

    <div class="index_page contanic_no_lock">
      <el-row :gutter="80">
        <!-- 播放区 -->
        <el-col :span="14">
            <br><br><br>
            <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                name="videoPlayer"
                id="video"
                :playsinline="true"
                :options="playerOptions"
                @play="onPlayerPlay($event)"
                @pause="onPlayerPause($event)"
                @ended="onPlayerEnded($event)"
                @waiting="onPlayerWaiting($event)"
                @timeupdate="onPlayerTimeupdate($event)"
                @statechanged="playerStateChanged($event)"
                @canplaythrough="onPlayerCanplaythrough($event)"
                @ready = "playerReadied"
            ></video-player>

        </el-col>
        <!-- 列表区 -->
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <br><br><br>
            <!-- 数据条目 -->
            <el-row :gutter="20">
              <div v-for="item in dataList" :key="item.id" @click="skipVideo(item)">
                <el-col :span="10">
                    <st_list_item_row_cop
                      item_num="1"
                      :id="item.id"
                      :title_txt="item.video_name"
                      :content_txt="item.video_desc"
                      :image_url="item.cover_url">
                    </st_list_item_row_cop>
                </el-col>
              </div>

              <el-col :span="20">
                <div class="page_div">
                  <el-pagination
                    layout="prev, pager, next"
                    :total="pagination.total"
                    :page-size="pagination.size"
                    :hide-on-single-page="true"
                    @current-change="handleCurrentChange">
                  </el-pagination>
                </div>
              </el-col>

            </el-row>
          </div>
        </el-col>
      </el-row>

    </div>

    <st_footer_cop
      :active-index="'1'"
      :is_lock_infeed="false">
    </st_footer_cop>
  </div>
</template>

<script>
import st_header from '../components/header_thr_about.vue'
import st_footer from '../components/footer.vue'
import st_list_item_row from "../components/list_item_video.vue"
import { getVideoPage } from '../utils/api'

import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

export default {
  name: 'about-video',
  components: {
    videoPlayer,
    st_header_cop: st_header,
    st_footer_cop: st_footer,
    st_list_item_row_cop: st_list_item_row,
  },
  data() {
    return {
      dataList:[],    //单页数据
      pagination:{    //分页数据
        page:1,
        size:4,
        total:100
      },

      playTime:'',
      current:'',
      playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
          autoplay: false, // 如果为true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 是否视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: "zh-CN",
          aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
              {
                  type: "video/mp4", // 类型
                  src:""// url地址
              }
          ],
          poster: "", // 封面地址
          notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: true, // 显示持续时间
              remainingTimeDisplay: false, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
          },
      },


    };
  },

  // beforeRouteLeave(){
  //   this.$refs.videoPlayer.player.pause()
  // },


  methods:{
    //请求网络数据
    getData(dataReq){
      let that = this;
      that.load.$emit('loading', true);
      getVideoPage(dataReq)
      .then(function(res){
        if(res.code===1000){
          that.dataList = res.data.list //记录当前页数据
          that.pagination.page = res.data.pagination.page 
          that.pagination.size = res.data.pagination.size 
          that.pagination.total = res.data.pagination.total 
          console.log(that.pagination)
          setTimeout(function(){
            that.load.$emit('loading', false);
            that.playerOptions.sources[0].src = that.dataList[0].video_url
          },1000)
        }else{
          console.error("error")
        }
      }).catch(function(err){
        console.log(err)
      })
    },
    //点击分页再次请求
    handleCurrentChange(val) {
      this.getData({"page":val,"size":4});
    },

    
    // 播放回调
    onPlayerPlay(player) {
        console.log("player play!", player);
    },

    // 暂停回调
    onPlayerPause(player) {
        console.log("player pause!", player);
    },

    // 视频播完回调
    onPlayerEnded($event) {
        console.log(player);
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting(player) {
        let time = localStorage.getItem("cacheTime")
        if(player.cache_.currentTime - Number(time) > 0.1){
            this.current = Number(time)
            this.playerReadied(player)
        }else{
            this.current = player.cache_.currentTime
        }
    },

    // 已开始播放回调
    onPlayerPlaying($event) {
        // console.log(player)
    },

    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata($event) {
        // console.log(player)
    },

    // // 当前播放位置发生变化时触发。
    onPlayerTimeupdate(player) {
        this.playTime = player.cache_.currentTime
        let playTime = player.cache_.currentTime
        setTimeout(function () {
            localStorage.setItem("cacheTime",playTime)
        },500)


        let time = localStorage.getItem("cacheTime")
        if(player.cache_.currentTime - Number(time) > 2){
            this.current = Number(time)
            this.playerReadied(player)
        }else{
            this.current = player.cache_.currentTime
        }
    },

    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay(player) {
        // console.log('player Canplay!', player)
    },

    //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough(player) {
        // console.log('player Canplaythrough!', player)
    },

    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
    },

    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player) {
        // console.log('example player 1 readied', player);
        player.currentTime(this.current)
    },

    skipVideo(item){
      console.log("点击了")
      //this.$refs.videoPlayer.player.onPlayerPause()
      this.playerOptions.sources[0].src = item.video_url
    }


  },
  created(){
    //默认请求
    this.getData({"page":1,"size":4});
  }
}
</script>

<style scoped lang="scss">

.vjs-custom-skin > .video-js .vjs-big-play-button {
    background-color: rgba(0,0,0,0.45);
    font-size: 3.0em;
    /* border-radius: 50%; */
    height: 1.5em !important;
    line-height:1.5em !important;
    margin-top: -1em !important;
}
/*这里用了第三方vue-video-player插件，但这个插件有bug，设置globalSetting:{controls:true}隐藏进度条不生效，故可设置插件样式进行隐藏vjs-progress-contro*/
.vjs-progress-control {
    /*visibility:hidden;       // 隐藏进度条*/
}.vjs-custom-skin > .video-js .vjs-big-play-button {
    background-color: rgba(0,0,0,0.45);
    font-size: 3.0em;
    /* border-radius: 50%; */
    height: 1.5em !important;
    line-height:1.5em !important;
    margin-top: -1em !important;
}
/*这里用了第三方vue-video-player插件，但这个插件有bug，设置globalSetting:{controls:true}隐藏进度条不生效，故可设置插件样式进行隐藏vjs-progress-contro*/
.vjs-progress-control {
    /*visibility:hidden;       // 隐藏进度条*/
}

.page_div{
  text-align: right;
  padding-right: 5%;
  margin-top: 20px;
}

.contanic {
  padding-top: 80px;
  height: 75vh;
}

.contanic_no_lock {
  padding-top: 80px;
  height: auto;
  min-height: 70vh;
}

.index_page {
  background: rgba(255, 255, 255, 0);
  padding-left: 5%;
  padding-right: 5%;
}

</style>



// WEBPACK FOOTER //
// src/view/th_vedio.vue